import {Component, OnInit, Input, OnChanges, SimpleChanges, ViewChild, ElementRef} from '@angular/core';
import {MultiImageChartConfigurations, MultiImageItem} from './multi.image.chart.configurations';
import {KlaHttpService} from '../../tools/services/kla.http.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'kla-multi-image-chart',
  templateUrl: './multi-image-chart.component.html',
  styleUrls: ['./multi-image-chart.component.scss'],
  standalone: true,
  imports: [ CommonModule ]
})
export class MultiImageChartComponent implements OnInit, OnChanges {

  @Input()
  public config: any;
  public totalValue = 0;
  public items: Array<any> = [];
  public focusedIndex = 0;

  @ViewChild('picturesRow') private picturesRow: ElementRef;

  constructor(private http: KlaHttpService) { }

  onContainerKeydown(e: KeyboardEvent) {
    if (e.key === 'Enter') {
      e.preventDefault();
      const items = this.picturesRow?.nativeElement.querySelectorAll('.multi-image-item');
      if (items?.length) { items[0].focus(); }
    }
  }

  onItemKeydown(e: KeyboardEvent, index: number) {
    const items = this.picturesRow?.nativeElement.querySelectorAll('.multi-image-item');
    if (!items?.length) { return; }
    if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
      e.preventDefault();
      this.focusedIndex = (index + 1) % items.length;
      items[this.focusedIndex].focus();
    } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
      e.preventDefault();
      this.focusedIndex = (index - 1 + items.length) % items.length;
      items[this.focusedIndex].focus();
    } else if (e.key === 'Escape') {
      e.preventDefault();
      const container = this.picturesRow?.nativeElement.closest('[role="group"]') as HTMLElement;
      if (container) { container.focus(); }
    }
  }

  ngOnInit() {
    this.draw();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.draw();
  }

  draw() {
    this.items = [];
    if (!this.config) {
      this.config = <MultiImageChartConfigurations> {};
    }
    if (this.config.items) {
      this.totalValue = 0;
      this.config.items.forEach((item: MultiImageItem) => {
        this.totalValue += item.value;
      });
      let sum = 0;
      this.config.items.forEach((item) => {
        const percentage = item.value / this.totalValue;
        const width = this.config.width * percentage;
        const height = this.config.height * percentage;
        const imageConfig = {
          id: item.image ?  item.image.id : '',
          width: width < 70 ? 70 : width,
          height: undefined,
          crop_config: item.image ? item.image.crop_config : {}
        };
        this.items.push({
          ...item,
          image: item.image ? this.http.getCroppedImagePath(imageConfig) : '',
          width: width,
          height: height,
        });
        sum += width;
      });
    }
  }
}
